import {
  FaRobot,
  FaChartBar,
  FaGlobe,
  FaClock,
  FaMoneyBillWave,
  FaCogs,
  FaComments,
} from "react-icons/fa";
import { TbLayoutDashboardFilled } from "react-icons/tb";
import { GrDocumentPerformance } from "react-icons/gr";
import { FaWeightScale } from "react-icons/fa6";

import p6029674 from "../../../assets/new/p6029674.jpg";
import p20943608 from "../../../assets/new/p20943608.jpg";
import p6030259 from "../../../assets/new/p6030259.jpg";

const mainFeature = [
  {
    id: "smart_lead_generation",
    title: "Capture More Leads",
    description:
      "Engage visitors with interactive chatbot conversations that qualify leads, collect key details, and drive meaningful customer actions.",

    icon: p6029674,
  },
  {
    id: "24_7_support",
    title: "Never lose a potential customer",
    description:
      "Stay connected with your visitors 24/7. Our AI chatbot answers questions instantly, ensuring no lead slips away and keeps your business responsive.",
    icon: p6030259,
  },
  {
    id: "increase_sales",
    title: "Increase Sales Effortlessly",
    description:
      "Maximize conversions by automating customer interactions, answering questions in real-time, and guiding users toward making a purchase.",
    icon: p20943608,
  },
];

const jaanoFeatures = [
  {
    id: "costEffective",
    title: "Cost-Effective Solution",
    description:
      "Save on hiring additional support agents while maintaining top-notch customer engagement.",
    icon: <FaMoneyBillWave className="w-10 h-10 " />,
  },
  {
    id: "neverLoseCustomer",
    title: "Never Lose a Potential Customer",
    description:
      "Stay connected with your visitors 24/7, ensuring no lead slips away.",
    icon: <FaClock className="w-10 h-10 " />,
  },
  {
    id: "automatedSupport",
    title: "24/7 Automated Support",
    description:
      "Ensure your website is always active, answering visitor questions and capturing leads.",
    icon: <FaRobot className="w-10 h-10 " />,
  },
  {
    id: "fasterResponse",
    title: "Faster Response Time",
    description:
      "Jaano delivers instant replies, reducing customer wait times and improving satisfaction.",
    icon: <FaComments className="w-10 h-10 " />,
  },
  {
    id: "customizableConversations",
    title: "Customizable Conversations",
    description: "Personalize Jaano's chatbot tone, language, and responses.",
    icon: <FaCogs className="w-10 h-10 " />,
  },
  {
    id: "boostRevenue",
    title: "Boost Your Revenue",
    description:
      "Focus on high-value tasks while Jaano handles routine inquiries.",
    icon: <GrDocumentPerformance className="w-10 h-10 " />,
  },
  {
    id: "insightfulAnalytics",
    title: "Insightful Analytics",
    description:
      "Get detailed reports on user interactions and improve conversions.",
    icon: <FaChartBar className="w-10 h-10 " />,
  },
  {
    id: "multiLanguage",
    title: "Multi-Language Support",
    description:
      "Reach a global audience with the ability to communicate in multiple languages.",
    icon: <FaGlobe className="w-10 h-10 " />,
  },
  {
    id: "scalableBusinesses",
    title: "Scalable for All Businesses",
    description:
      "Whether you're a startup or an enterprise, our AI chatbot service adapts to your growth and evolving needs.",
    icon: <FaWeightScale className="w-10 h-10 " />,
  },
  {
    id: "userFriendlyDashboard",
    title: "User-Friendly Dashboard",
    description:
      "Manage conversations, track leads, and customize settings from an intuitive dashboard designed for simplicity.",
    icon: <TbLayoutDashboardFilled className="w-10 h-10 " />,
  },
];

export { mainFeature, jaanoFeatures };
